import * as React from "react";
import { Text, VStack } from "@chakra-ui/react";
import { ImageUploader } from "components";
import { IMAGE_HEIGHT } from "../../duck";

interface FileInputProps {
  label: string;
  name: string;
}

const FileInput: React.FC<FileInputProps> = ({ name, label }) => (
  <VStack spacing={0} flex="1">
    <Text mb="4" textAlign="center">
      {label}
    </Text>
    <ImageUploader
      name={name}
      enableZoom
      boxProps={{ h: IMAGE_HEIGHT }}
      stretch
    />
  </VStack>
);

export default FileInput;
